import httpRequest from "utils/httpRequest";
const URL = "/api";

export const sendTestingSms = async (e_line, cur_page) => {
  const requestBody = {
    e_line,
    cur_page,
  };
  try {
    console.log("< send-testing-sms > ", e_line, cur_page); 
    const response = await httpRequest("post", `${URL}/send-testing-sms`, requestBody);
    console.log("response of send-testing-sms > ", response); 
    return response;
  } catch (error) {
    console.error(error);
  }
};
